"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable react/no-danger */


var react_1 = __importDefault(require("react"));

var LibraryItemAutosync_1 = __importDefault(require("./LibraryItemAutosync"));

require("./ExcelPPTLibraryItemCard.css");

var MiniLoader_1 = __importDefault(require("../../layout/MiniLoader")); // TODO: this code needs to be refactored


var ExcelPPTLibraryItemCard = function (_a) {
  var loadingContent = _a.loadingContent,
      html = _a.html,
      showAutoSync = _a.showAutoSync,
      sourceName = _a.sourceName,
      groupName = _a.groupName,
      sharePointItemUrl = _a.sharePointItemUrl,
      fileName = _a.fileName,
      props = __rest(_a, ["loadingContent", "html", "showAutoSync", "sourceName", "groupName", "sharePointItemUrl", "fileName"]);

  return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
    children: [(0, jsx_runtime_1.jsxs)("div", __assign({}, props, {
      className: "rich-text-library-item-edit"
    }, {
      children: [loadingContent && (0, jsx_runtime_1.jsx)("div", __assign({
        className: "mini-loader-container-wrapper"
      }, {
        children: (0, jsx_runtime_1.jsx)("div", __assign({
          className: "mini-loader-container"
        }, {
          children: (0, jsx_runtime_1.jsx)(MiniLoader_1.default, {}, void 0)
        }), void 0)
      }), void 0), !loadingContent && (0, jsx_runtime_1.jsx)("div", {
        "data-testid": "excel-content-item",
        className: "content-item-container css-override",
        dangerouslySetInnerHTML: {
          __html: html
        }
      }, void 0)]
    }), void 0), !loadingContent && showAutoSync && (0, jsx_runtime_1.jsx)(LibraryItemAutosync_1.default, {
      sourceName: sourceName,
      groupName: groupName,
      sharePointItemUrl: sharePointItemUrl,
      fileName: fileName
    }, void 0)]
  }, void 0);
};

exports.default = react_1.default.memo(ExcelPPTLibraryItemCard);